import { DiscountCategory } from "@redotech/redo-discounts-common/discount/discount-db-parser";
import { BigcommerceCombineDiscountField } from "./fields/bigcommerce-combine-discount-field";
import { ExpirationField } from "./fields/expiration-field";
import { MinimumPurchaseAmountField } from "./fields/minimum-purchase-amount-field";
import { MinimumQuantityField } from "./fields/minimum-quantity-field";
import { ShowHiddenRecoverFieldsField } from "./fields/show-hidden-recover-fields-field";
import { DiscountSettingsSectionProps } from "./types";

export function BigcommerceFreeShippingSettings({
  formState,
  category,
  showHiddenRecoverFields,
  setShowHiddenRecoverFields,
}: DiscountSettingsSectionProps) {
  const isRecover = category === DiscountCategory.RECOVER;
  const showRecoverGatedFields = !isRecover || showHiddenRecoverFields;

  return (
    <>
      <BigcommerceCombineDiscountField
        setValue={formState.setCombineDiscountWith}
        value={formState.combineDiscountWith}
      />
      <ExpirationField
        category={category}
        codeGenerationStrategy={formState.codeGenerationStrategy}
        expiration={formState.expiration}
        setExpiration={formState.setExpiration}
      />
      {showRecoverGatedFields && (
        <>
          <MinimumQuantityField
            setValue={formState.handleSetMinimumQuantity}
            value={formState.minimumQuantity}
          />
          <MinimumPurchaseAmountField
            setValue={formState.handleSetMinimumSubtotal}
            value={formState.minimumSubtotal}
          />
        </>
      )}
      <ShowHiddenRecoverFieldsField
        setValue={setShowHiddenRecoverFields}
        value={showHiddenRecoverFields}
      />
    </>
  );
}
